export default __webpack_public_path__ + "static/media/g.2f7d2cbff8abe137f0a0ced0d82450e9.mp3";